export const ProjectsRoutes = {
    projects: (origin: string) => `${origin}/projects`,
    projectsFilters: (origin: string) => `${origin}/projects/filters`,
};
